import Icon from '../components/Icon.vue'

Icon.register({
  undo: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M212.3 224.3h-200.3c-6.6 0-12-5.4-12-12v-200.3c0-6.6 5.4-12 12-12h48c6.6 0 12 5.4 12 12v78.1c45.8-50.8 112.3-82.6 186.2-82.1 136.9 1 246.4 111.6 246.2 248.5-0.3 136.7-111.2 247.5-248 247.5-64.1 0-122.5-24.3-166.5-64.2-5.1-4.6-5.3-12.6-0.5-17.4l34-34c4.5-4.5 11.7-4.7 16.4-0.5 31 27.5 71.9 44.1 116.6 44.1 97.3 0 176-78.7 176-176 0-97.3-78.7-176-176-176-58.5 0-110.3 28.5-142.3 72.3h98.3c6.6 0 12 5.4 12 12v48c0 6.6-5.4 12-12 12z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/undo.js
// module id = 2047
// module chunks = 0